<div class="agpr-landingPage-sidebar" [id]="id">
    <div class="agpr-landingPage-sidebar-title">
        <h2 class="agpr-landingPage-sidebar-title-text">{{ header | localize }}</h2>
    </div>
    <div class="agpr-landingPage-sidebar-text">
        {{ description | localize }}
        <a
            class="agpr-landingPage-sidebar-linkText"
            target="_blank"
            [href]="externalUrl"
            [attr.aria-describedby]="id + '_externalLink'"
        >
            {{ linkText | localize }}
            <span [id]="id + '_externalLink'" class="u-srOnly">{{ 'Dashboard.helpCenter.externalLink' | localize}}</span>
            <i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square"></i>
        </a>
    </div>
</div>
